import React from "react";
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  FormErrorMessage,
  Textarea,
  HStack,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";

interface PermissionFormProps {
  initialData?: any;
  onSubmit: (data: any) => void;
  onCancel: () => void;
}

export const PermissionForm: React.FC<PermissionFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      resource: initialData?.resource || "",
      label: initialData?.label || "",
      description: initialData?.description || "",
    },
  });

  const onFormSubmit = (data: any) => {
    onSubmit(data);
  };

  const isReadOnly = !!initialData;

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <VStack spacing={6} align="stretch">
        {!initialData && (
          <Alert status="info" borderRadius="md">
            <AlertIcon />
            <AlertDescription>
              با افزودن یک Resource، به طور خودکار 4 مجوز (مشاهده، ایجاد،
              ویرایش، حذف) ایجاد می‌شود.
            </AlertDescription>
          </Alert>
        )}

        {isReadOnly && (
          <Alert status="info" borderRadius="md">
            <AlertIcon />
            <AlertDescription>
              در حالت ویرایش فقط عنوان فارسی و توضیحات این منبع قابل تغییر است.
            </AlertDescription>
          </Alert>
        )}

        <FormControl isInvalid={!!errors.resource} isRequired>
          <FormLabel>نام Resource (انگلیسی)</FormLabel>
          <Input
            {...register("resource", {
              required: "نام Resource الزامی است",
              // pattern: {
              //   value: /^[a-z_]+$/,
              //   message: "فقط حروف کوچک انگلیسی و _ مجاز است",
              // },
            })}
            placeholder="مثال: products"
            isDisabled={isReadOnly}
          />
          <FormErrorMessage>
            {errors.resource?.message as string}
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.label} isRequired>
          <FormLabel>عنوان فارسی</FormLabel>
          <Input
            {...register("label", { required: "عنوان الزامی است" })}
            placeholder="مثال: محصولات"
          />
          <FormErrorMessage>{errors.label?.message as string}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.description}>
          <FormLabel>توضیحات</FormLabel>
          <Textarea
            {...register("description")}
            placeholder="توضیحات کامل درباره این Resource"
            rows={3}
          />
          <FormErrorMessage>
            {errors.description?.message as string}
          </FormErrorMessage>
        </FormControl>

        <HStack spacing={3} pt={4}>
          <Button type="submit" colorScheme="brand" flex={1}>
            {initialData ? "ذخیره تغییرات" : "ایجاد 4 مجوز"}
          </Button>
          <Button onClick={onCancel} variant="outline" flex={1}>
            انصراف
          </Button>
        </HStack>
      </VStack>
    </form>
  );
};
